/* Gumly+ shared behavior:
   - Typewriter on .gw-typewriter (data-text / data-speed / data-delay)
   - Scroll reveal on .reveal -> .reveal.in
   - Carousel arrows: .scr-arrow with data-scroll-target inside .scroller-wrap
   - Scrolled nav class on .nav
*/
(function () {
  // Always open a page at the top. The browser default ('auto') restores the
  // previous scroll position on reload / back-forward, which made tall pages
  // (e.g. the pouch-information pre-lander) re-open at the bottom after a reload.
  if ('scrollRestoration' in history) { try { history.scrollRestoration = 'manual'; } catch (e) {} }

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function initTypewriter(el) {
    if (el.dataset.gwReady) return; el.dataset.gwReady = '1';
    var text = el.dataset.text || el.textContent || '';
    var speed = parseInt(el.dataset.speed || '32', 10);
    var delay = parseInt(el.dataset.delay || '0', 10);
    // Set ghost (reserves layout) + live overlay
    el.classList.add('typewriter');
    el.innerHTML = '<span class="tw-ghost" aria-hidden="true">' + text + '</span><span class="tw-live" aria-hidden="true"></span>';
    var live = el.querySelector('.tw-live');
    var started = false;
    function start() {
      if (started) return; started = true;
      var i = 0;
      function tick() {
        i++;
        live.textContent = text.slice(0, i);
        if (i < text.length) setTimeout(tick, speed);
        else { var c = document.createElement('span'); c.className = 'tw-caret tw-caret-fade'; live.appendChild(c); }
      }
      var c0 = document.createElement('span'); c0.className = 'tw-caret'; live.appendChild(c0);
      setTimeout(tick, delay);
    }
    var r = el.getBoundingClientRect();
    if (r.top < (window.innerHeight || 800) * 0.95) { start(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(el);
  }

  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800) * 0.95) el.classList.add('in');
      else io.observe(el);
    });
    setTimeout(function () { document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { el.classList.add('in'); }); }, 1500);
  }

  function initArrows() {
    document.querySelectorAll('.scr-arrow').forEach(function (btn) {
      if (btn.dataset.gwReady) return; btn.dataset.gwReady = '1';
      btn.addEventListener('click', function () {
        var target = btn.dataset.scrollTarget || '.scroller, .video-row, .flavor-row, .reviews-row';
        // Look for the scroller in the nearest .scroller-wrap, otherwise fall
        // back to the enclosing section. The reviews section keeps its arrows
        // inside .reviews-foot (outside the scroll-wrap), so we need this.
        var host = btn.closest('.scroller-wrap') || btn.closest('section');
        if (!host) return;
        var s = host.querySelector(target);
        if (!s) return;
        var dir = btn.classList.contains('prev') ? -1 : 1;
        // Scroll by one card width + gap so each click advances one item.
        var first = s.firstElementChild;
        var step = s.clientWidth * 0.8;
        if (first) {
          var rect = first.getBoundingClientRect();
          var style = getComputedStyle(s);
          var gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 16;
          if (rect.width > 0) step = rect.width + gap;
        }
        s.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  function initNav() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    function onScroll() { nav.classList.toggle('scrolled', window.scrollY > 24); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initNavDrawer() {
    var drawer = document.querySelector('[data-nav-drawer]');
    var burger = document.querySelector('[data-nav-burger]');
    if (!drawer || !burger || drawer.dataset.gwReady) return;
    drawer.dataset.gwReady = '1';
    var panel = drawer.querySelector('.nav-drawer-panel');

    function open() {
      drawer.hidden = false;
      void drawer.offsetWidth; // force reflow so the slide-in transition runs
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      var settled = false;
      function hide() { if (settled) return; settled = true; drawer.hidden = true; }
      if (panel) {
        panel.addEventListener('transitionend', function handler() {
          panel.removeEventListener('transitionend', handler); hide();
        });
      }
      setTimeout(hide, 400); // fallback if transitionend never fires
    }

    burger.addEventListener('click', open);
    drawer.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.querySelectorAll('.nav-drawer-links a').forEach(function (a) {
      a.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760) close();
    });
  }

  function initFaqAccordion() {
    document.querySelectorAll('[data-faq-grid]').forEach(function (grid) {
      if (grid.dataset.gwReady) return; grid.dataset.gwReady = '1';
      var pills = grid.querySelectorAll('details.faq-pill');
      pills.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          pills.forEach(function (other) {
            if (other !== d && other.open) other.open = false;
          });
        });
      });
    });
  }

  function initGalleryThumbs() {
    document.querySelectorAll('[data-gshop-thumbs]').forEach(function (strip) {
      if (strip.dataset.gwReady) return; strip.dataset.gwReady = '1';
      var col = strip.closest('.gshop-media-col') || strip.parentElement;
      var media = col && col.querySelector('[data-gshop-media]');
      if (!media) return;
      var slides = Array.prototype.slice.call(media.querySelectorAll('.gshop-slide'));
      if (slides.length < 2) return;

      strip.innerHTML = '';
      var thumbs = [];
      slides.forEach(function (slide, i) {
        var src = '';
        var img = slide.querySelector('img.gshop-media-el');
        if (img) src = img.getAttribute('src');
        if (!src) {
          var vid = slide.querySelector('video.gshop-media-el');
          if (vid) src = vid.getAttribute('poster') || '';
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gshop-thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        if (src) {
          var t = document.createElement('img');
          t.src = src; t.loading = 'lazy'; t.alt = '';
          b.appendChild(t);
        } else {
          b.classList.add('gshop-thumb--video');
        }
        b.addEventListener('click', function () {
          var left = slide.getBoundingClientRect().left - media.getBoundingClientRect().left + media.scrollLeft;
          media.scrollTo({ left: left, behavior: 'smooth' });
        });
        strip.appendChild(b);
        thumbs.push(b);
      });

      function syncActive() {
        var center = media.scrollLeft + media.clientWidth / 2;
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === best); });
      }
      var raf;
      media.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(syncActive);
      }, { passive: true });
    });
  }

  // iOS Safari often ignores the `autoplay` attribute (esp. for videos that
  // start off-screen in the horizontal scrollers, and with preload="metadata").
  // Force playback in JS: set muted/playsInline as PROPERTIES (WebKit attribute
  // bug), call play() with rejection handling, retry on readiness, and (re)start
  // each video the moment it scrolls into view via an IntersectionObserver.
  function initVideos() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;

    function tryPlay(v) {
      // Re-assert the autoplay-permitting properties every time, then play.
      v.muted = true; v.playsInline = true; v.loop = v.loop || v.hasAttribute('loop');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) tryPlay(e.target);
        else { try { e.target.pause(); } catch (err) {} }
      });
    }, { threshold: 0.01 }) : null;

    vids.forEach(function (v) {
      if (v.dataset.gwVideoReady) return; v.dataset.gwVideoReady = '1';
      v.muted = true; v.playsInline = true;
      // Retry once data is ready (covers preload="metadata" sections where the
      // first play() call fires before any frames have buffered).
      v.addEventListener('loadeddata', function () { tryPlay(v); }, { once: true });
      v.addEventListener('canplay', function () { tryPlay(v); }, { once: true });
      // Kick immediately so in-view videos (e.g. the hero) start before the
      // observer fires; the observer then keeps off-screen videos covered.
      tryPlay(v);
      if (io) io.observe(v);
    });
  }

  function bootAll() {
    document.querySelectorAll('.gw-typewriter').forEach(initTypewriter);
    initReveal();
    initArrows();
    initNav();
    initNavDrawer();
    initFaqAccordion();
    initGalleryThumbs();
    initVideos();
  }

  // Lock the viewport height into --vh (in px) so full-height elements (the hero)
  // don't resize when in-app browsers (Instagram/Facebook) slide their toolbar
  // in/out on scroll — the classic "page keeps jumping" bug. Those webviews often
  // ignore svh/dvh and report vh dynamically, so we pin a pixel value instead.
  // Recompute ONLY on a real width change (rotation), never on the height-only
  // change the toolbar causes — otherwise it would jump again.
  (function lockViewportHeight() {
    var lastW = window.innerWidth;
    function setVH() {
      document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
    }
    setVH();
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastW) { lastW = window.innerWidth; setVH(); }
    });
    window.addEventListener('orientationchange', function () { setTimeout(setVH, 250); });
  })();

  ready(bootAll);
  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:section:reorder', bootAll);
})();
